/* 棚内の棚 */
import React from 'react';
import { Collapse, Card } from 'react-bootstrap';

interface Props {
  id: string;
  label: string;
  is_open: boolean;
  handleClick: React.MouseEventHandler<HTMLDivElement>;
}

const ShelfInShelf: React.FC<Props> = ({ id, label, is_open, handleClick, children }) => {
  return (
    <Card className="shelf mx-auto px-0 col-12">
      <Card.Header
        className={`shelf-header ${is_open && 'is-open'}`}
        onClick={handleClick}
        aria-expanded={is_open}
        id={id}
      >
        {label}
        <span className="ac-icon"></span>
      </Card.Header>
      <Collapse className="collapse-body" in={is_open}>
        <div>
          <Card.Body className="p-2">
            <div>{children}</div>
          </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
};

export default ShelfInShelf;
